import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'
import type { TypeComponentLinkSkeleton } from './TypeComponentLink'
import type { TypeSeoSkeleton } from './TypeSeo'

export interface TypeHelpArticleFields {
  title: EntryFieldTypes.Symbol
  slug?: EntryFieldTypes.Symbol
  slugLink?: EntryFieldTypes.EntryLink<TypeComponentLinkSkeleton>
  seo?: EntryFieldTypes.EntryLink<TypeSeoSkeleton>
  customBreadcrumbs?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton>>
  hideFeedbackButton?: EntryFieldTypes.Boolean
  body?: EntryFieldTypes.RichText
}

export type TypeHelpArticleSkeleton = EntrySkeletonType<TypeHelpArticleFields, 'helpArticle'>
export type TypeHelpArticle<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHelpArticleSkeleton,
  Modifiers,
  Locales
>

export function isTypeHelpArticle<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHelpArticle<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'helpArticle'
}
